import jwt from "jsonwebtoken";
import { checkResponse } from "../utils/checkResponse";
import {
  APIKey,
  Authorization,
  Channel,
  DomainAPI,
  SecretApiKey,
  SecretApiKeyExpires,
  _pick,
} from "../utils/setting";

const sms = {
  state: {
    listSMS: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
  },
  effects: (dispatch) => ({
    getList(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/sms/getList`;

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
          .then((res) => {
          checkResponse(res);
          if (res.code === 1) {
            _this.setState({
              listSMS: res.data.list,
              total: res.data.total,
              count: res.data.count,
            });
          }
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
    sendSMSToListPhone(payload, rootState) {
      const _this = this;
      let myHeaders = new Headers();
      let key = jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);
      const url = `${DomainAPI}${Channel}/api/secure/sms/sendSMSToListPhone`;

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res) => {
          checkResponse(res);
          return res;
        })
        .catch((err) => {
          return { code: 0, error: err, message: err.toString() };
        });
    },
  }),
};
export default sms;
